var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{staticClass:"mt-2 border-text",attrs:{"outline":"","rules":_vm.useInternalRules 
      ? (
          _vm.tipoRegla == '1' ? _vm.reglasTipo.tipo1 :
          _vm.tipoRegla == '2' ? _vm.reglasTipo.tipo2 :
          _vm.tipoRegla == '3' ? _vm.reglasTipo.tipo3 :
          _vm.tipoRegla == '5' ? _vm.reglasTipo.tipo4 :
          _vm.reglasTipo.tipo0
        )
      : [],"label":_vm.label,"disabled":_vm.disabled},on:{"keypress":function($event){return _vm.filter($event)}},model:{value:(_vm.dni),callback:function ($$v) {_vm.dni=$$v},expression:"dni"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }